import { useMemo } from "react";
import {
  PolicyCalculationType,
  PolicyDayPeriodType,
  PolicyTargetStatus,
} from "shared";
import { DateTime } from "luxon";

import { InputTextAddon } from "../../../../../common/Atoms/InputTextAddon";
import { fieldIsValid } from "../../../../lib/helper";
import { Select } from "../../../../../common/Atoms/Select";

import { IFieldProps } from "./Fields/fieldProps";

export function GracePeriod({
  handleChange,
  policyFormData,
  invalids,
}: IFieldProps) {
  const options = useMemo(() => {
    return [
      {
        label: `Day${policyFormData.grace_period === 1 ? `` : `s`}`,
        value: PolicyDayPeriodType.DAYS,
        tooltip: `All calendar days`,
      },
      {
        label: `Weekday${policyFormData.grace_period === 1 ? `` : `s`}`,
        value: PolicyDayPeriodType.WEEKDAYS,
        tooltip: `Does not count weekends. Includes any local holidays.`,
      },
    ];
  }, [policyFormData.grace_period]);

  function handleDaysTypeChange({ value }) {
    return handleChange({
      value,
      name: `day_period_type`,
    });
  }

  // Mirrors calculateProRata: issue date when the grace period uses it, never before the earliest interest date
  const startDate = policyFormData.target_status === PolicyTargetStatus.ISSUED ? `issue date` : `due date`;
  let description = ``;

  if (policyFormData.calculation_type === PolicyCalculationType.PRORATA) {
    description = `Interest is calculated from the ${startDate}`;

    if (policyFormData.repeating && policyFormData.repeat_frequency) {
      description += `, or the most recent late fee when repeating`;
    }

    if (policyFormData.earliest_interest_date_string) {
      description += `, and never earlier than ${DateTime.fromISO(policyFormData.earliest_interest_date_string).toFormat(`dd LLL yyyy`)}`;
    }

    description += `.`;
  }

  const dropdown = (
    <Select
      options={ options }
      selected={ policyFormData.day_period_type }
      onChange={ handleDaysTypeChange }
      name={ `day_period_type` }
      className={ `rounded-l-none` }
      nestedInTextField
    />
  );

  return (
    <>
      <InputTextAddon
        label={ `Grace Period` }
        description={ description }
        helpIcon={ `How many days after the ${startDate} to wait before applying the late fee? To give a margin of time to allow reconciliation` }
        value={ policyFormData.grace_period }
        onChange={ handleChange }
        name={ `grace_period` }
        invalid={ fieldIsValid(`grace_period`, invalids) }
        dataType={ `number` }
        addOnElement={ dropdown }
      />
    </>
  );
}
